<template>
  <a-popover v-model="showNotice" overlay-class-name="header-notice" trigger="click" placement="bottomRight">
    <template slot="content">
      <a-spin :spinning="loading">
        <a-tabs :defaultActiveKey="'0'" @change="handleTabChange" class="header-notice-content" :tab-bar-gutter="25">
          <a-tab-pane key="0">
            <span slot="tab">
              未读
              <span v-if="totalSum['unRead']">({{ totalSum['unRead'] }})</span>
            </span>
            <template v-if="totalSum['unRead']">
              <a-list>
                <template >
                  <a-list-item v-for="item in list['unRead']" data-ga-id="菜单栏-点击具体通知" :key="item.id" @click="handleReadNotify(item)">
                    <a-list-item-meta :description="item.createAt">
                      <div slot="title">
                        <a href="javascript:;">{{ item.companyName }}</a>
                        <p class="ant-list-item-meta-description">{{ item.content }}</p>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </template>
              </a-list>
              <div class="footer-action" style="display: flex;">
                <a class="item muted" @click="setRead('task')"></a>
                <a @click="handleReadAll" class="item muted">消灭所有未读</a>
                <a @click="jumpToNotifyList('/notify?type=&status=0')" class="item muted" data-ga-id="菜单栏-点击查看更多" >查看更多</a>
              </div>
            </template>
            <template v-else>
              <div class="notFound">
                <img src="../../../assets/image/notify/ticket.svg" alt="not found" />
                <div>暂无未读消息</div>
              </div>
            </template>
          </a-tab-pane>
          <a-tab-pane :key="''">
            <span slot="tab">
              全部
              <!-- <span v-if="totalSum['all']">({{ totalSum['all'] }})</span> -->
            </span>
            <template v-if="totalSum['all']">
              <a-list>
                <template v-for="item in list['all']">
                  <a-list-item :key="item.id" @click="handleReadNotify(item)">
                    <a-list-item-meta :description="item.createAt">
                      <div slot="title">
                        <a href="javascript:;">{{ item.companyName }}</a>
                        <p class="ant-list-item-meta-description" v-html="item.content" />
                      </div>
                      <!-- <a-avatar
                        slot="avatar"
                        :src="item.avatar"
                      />-->
                    </a-list-item-meta>
                  </a-list-item>
                </template>
              </a-list>
              <div class="footer-action">
                <a class="item muted" @click="setRead('message')"></a>
                <a @click="jumpToNotifyList('/notify?type=&status=')" class="item muted">查看更多</a>
              </div>
            </template>
            <template v-else>
              <div class="notFound">
                <img src="../../../assets/image/notify/laba.svg" alt="not found" />
                <div>暂无数据</div>
              </div>
            </template>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </template>
    <a-badge data-ga-id="菜单栏-点击通知按钮" :count="totalSum.unRead" style="transform: scale(.8)">
      <iconfont icon-class="system" iconSize="30" style="margin-right:7px" />
      <a href="#" class="head-example"></a>
    </a-badge>
  </a-popover>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
// import {noReads} from "../../../api/notify";
import { showMsgNotification } from '../../../assets/js/notify';
// import {selfList} from "../../../api/task";
import { notifyRead, notifyCount, notifyList, notifyReadAll } from '@/api/notify.js';

export default {
  data() {
    return {
      showNotice: false,
      loading: false,
      total: 0,
      messageTotal: 0,
      totalSum: {
        all: 0,
        unRead: 0,
        read: 0
      },
      list: [],
      task: {
        page: 1,
        pageSize: 5,
        total: 0,
        list: []
      }
    };
  },
  computed: {
    ...mapState({
      socketAction: state => state.socketAction,
      currentOrganization: state => state.currentOrganization
    })
  },
  watch: {
    socketAction(val) {
      if (val.action === 'notice') {
        this.init();
      } else if (val.action === 'task') {
        this.init();
        const permission = showMsgNotification(val.title, val.msg, {
          icon: val.data.notify.avatar
        });
        if (permission === false) {
          this.$message.info(val);
        }
      }
    }
  },
  created() {
    this.initNotifyList();
  },
  methods: {
    initNotifyList() {
      this.getUnReadTotal();
      this.getNotifyList();
      this.getNotifyList('1');
      this.getNotifyList('0');
    },
    jumpToNotifyList(path) {
      window.open(window.location.origin + path);
    },
    handleReadAll() {
      this.loading = true;
      notifyReadAll('').then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.initNotifyList();
          this.$message.success(res.data || 'success');
        }
      });
    },
    handleReadNotify(row) {
      notifyRead(row.id).then(res => {
        let url = ``;
        let query = ``;
        switch (row.page) {
        case 1:
          //跳转项目页面
          query = `?id=${row.companyId}`;
          url = `${url}/project/detail`;
          break;
        case 2:
          //跳转Vote页面
          query = `?companyId=${row.companyId}`;
          url = `${url}/project/meetingList`;
          break;
        case 3:
          //跳转meeting页面
          query = ``;
          url = `${url}/meeting`;
          break;
        }
        this.jumpToNotifyList(`${url}${query}`);
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.getNotifyList('0');
          this.getNotifyList('1');
        }
      });
    },
    handleTabChange(key) {
      this.getNotifyList(key);
    },
    async getUnReadTotal() {
      // 获取全部未读的消息数量
      const res = await notifyCount({ type: '', isRead: 0 });
      this.total = res.data.count || 0;
    },
    async getNotifyList(isRead) {
      this.loading = true;
      const res = await notifyList({
        type: '',
        page: 1,
        pageSize: 3,
        isRead: isRead
      });
      this.loading = false;
      isRead = isRead ? Number(isRead) : '';
      switch (isRead) {
      case 0: // 未读
        this.list.unRead = res.data.list;
        this.totalSum.unRead = res.data.total;
        break;
      case 1: //已读
        this.list.read = res.data.list;
        this.totalSum.read = res.data.total;
        break;
      default:
        this.list.all = res.data.list;
        this.totalSum.all = res.data.total;
        break;
      }
    },
    init() {
      this.fetchNotice();
      this.getTasks();
    },
    fetchNotice() {
      // const app = this
      // noReads().then(res => {
      //   app.list = res.data.list
      //   app.messageTotal = res.data.total
      //   app.total = app.messageTotal + app.task.total
      //   app.totalSum = res.data.totalSum
      // })
    },
    setRead(type) {
      this.total -= this.list[type].length;
      this.list[type] = [];
    },
    showMore(key) {
      switch (key) {
      default:
        this.showNotice = false;
        this.$router.push('/notify/notice');
      }
    },
    getTasks() {
      // selfList({ page: this.task.page, pageSize: this.task.pageSize }).then(res => {
      //   this.task.list = res.data.list
      //   this.task.total = res.data.total
      //   this.total = this.messageTotal + this.task.total
      // })
    },
    formatTime(time) {
      return moment(time).format('YY年MM月DD日 HH:mm');
    },
    showDiff(time, time2) {
      let diff = moment(time).diff(moment(time2), 'days');
      if (diff <= 0) {
        diff = moment(time).diff(moment(time2), 'hours');
        diff += '小时';
      } else {
        diff += '天';
      }
      return diff;
    }
  }
};
</script>

<style lang="less">
.header-notice {
  .ant-popover-inner-content {
    padding: 0;

    .ant-tabs-bar {
      margin-bottom: 0 !important;
    }

    .ant-list {
      .ant-list-item {
        padding: 12px 24px;
        transition: all 0.3s;

        &:hover {
          background: #e6f7ff;
        }
      }
    }
  }

  .header-notice-content {
    width: 340px;

    .ant-tabs-bar {
      text-align: center;
      margin-bottom: 5px;
    }

    .ant-list-item-meta-title {
      p {
        margin-bottom: 8px;
        position: relative;
      }
    }

    .ant-list-item-meta-description {
      font-size: 12px;
    }

    .ant-list-item:hover {
      /*background: #e6f7ff;*/
      cursor: pointer;
    }

    .notFound {
      text-align: center;
      padding: 73px 0 88px 0;
      color: rgba(0, 0, 0, 0.45);
      height: 275px;

      img {
        margin-bottom: 16px;
      }
    }

    .footer-action {
      border-top: 1px solid #e8e8e8;
      padding: 12px 0;

      .item {
        width: 49%;
        display: inline-block;
        text-align: center;
      }
    }
  }
}
</style>
